import React, { useEffect, useState } from "react";
import "./NewAccountForm.scss";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import "../../../assets/styles/general/select.scss";
import InputMask from "react-input-mask";
import HeaderSimple from "../../components/HeaderSimple/HeaderSimple";
import { Link, useNavigate } from "react-router-dom";
import api from "../../../services/api"; // Usa a instância `api` com interceptors

const COUNTRY_OPTIONS = [
  { label: "Brasil", value: "Brasil" },
  { label: "Argentina", value: "Argentina" },
  { label: "Paraguay", value: "Paraguay" },
  { label: "Uruguay", value: "Uruguay" },
  { label: "Colombia", value: "Colombia" },
];

function NewAccountForm() {
  const { t } = useTranslation();
  const [errors, setErrors] = useState({});
  const [promoterOptions, setPromoterOptions] = useState([]);
  const navigate = useNavigate();
  const [isPromoter, setIsPromoter] = useState(true);
  const [isClearing, setIsClearing] = useState(false);
  const [cep, setCep] = useState("");
  const [endereco, setEndereco] = useState({});
  const [isActive, setIsActive] = useState(true);
  const [isSelected, setIsSelected] = useState(false);
  const [formData, setFormData] = useState({
    code: "",
    name: "",
    profile_name: "",
    profile_value: "",
    email: "",
    password: "",
    password_confirmation: "",
    phone: "",
    profile_type: "",
    accept_regulation: "",
    state: "",
    cep: "",
    city: "",
    neighborhood: "",
    address: "",
    number: "",
    complement: "",
    country: "",
    cpf: "",
  });

  useEffect(() => {
    // Agora não precisa mais pegar language do localStorage,
    // O interceptor já lida com o idioma, se estiver configurado.
    api
      .get("/distribuitors")
      .then((response) => {
        const options = response.data.map((promoter) => ({
          value: promoter.id,
          label: promoter.title,
        }));
        setPromoterOptions(options);
      })
      .catch((error) => {
        console.error("Erro ao buscar distribuidores:", error);
      });
  }, []);

  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setFormData((prev) => ({
      ...prev,
      accept_regulation: isChecked,
    }));
    setErrors((prevErrors) => ({ ...prevErrors, accept_regulation: null }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setIsSelected(true); 
    setFormData((prevFormData) => ({
      ...prevFormData,
      profile_value: "", 
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    console.log(formData)
    try {
      const response = await api.post("/user/create", formData);

      const access_token = response.data.access_token;
      const authorizationType = response.data.token_type;
      const fullToken = `${authorizationType} ${access_token}`;

      localStorage.setItem("token", fullToken);

      // Busca dados do usuário após cadastro
      const responseUser = await api.get("/user");
      const roles = responseUser.data.level.roles;
      const role = Object.keys(roles).find((key) => roles[key] === true);
      localStorage.setItem("typeUser", role);

      navigate("/cadastro-realizado");
    } catch (error) {
      console.error("Erro:", error);
      if (error.response && error.response.data) {
        const serverErrors = error.response.data;
        const formattedErrors = Object.fromEntries(Object.entries(serverErrors).map(([key, value]) => [key, value[0]]));
        setErrors(formattedErrors);
      } else {
        setErrors({ general: t("common-submit-error") });
      }
    }
  };

  const handleCepChange = (e) => {
    const country = formData.country;

    if (country === "Argentina") {
      setFormData((prevData) => ({
        ...prevData,
        cep: e.target.value,
        address: "",
        neighborhood: "",
        city: "",
        state: "",
        country: "Argentina",
      }));
      return;
    }

    const raw = e.target.value.replace(/\D/g, "");
    const isBrasilFlow = country === "Brasil" || country === "";

    let cepDisplay;
    if (country === "Paraguay" || country === "Uruguay") {
      cepDisplay = raw.slice(0, 5);
    } else {
      cepDisplay = formatCep(raw.slice(0, 8));
    }

    setFormData((prevData) => ({
      ...prevData,
      cep: cepDisplay,
      address: "",
      neighborhood: "",
      city: "",
      state: "",
      country:
        country === "Paraguay" || country === "Uruguay"
          ? country
          : "Brasil",
    }));
    if (raw.length <= 8) {
      setCep(raw);
    }
    if (isBrasilFlow && raw.length === 8) {
      fetchEndereco(raw.slice(0, 8));
    }
  };

  const formatCep = (value) => {
    if (value.length > 5) {
      return value.replace(/^(\d{5})(\d)/, "$1-$2");
    }
    return value;
  };

  const fetchEndereco = async (cep) => {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();
      console.log(data)
      if (data.erro) {
        alert(t("common-cep-not-found"));
        setFormData((prevData) => ({
          ...prevData,
          address: "",
          neighborhood: "",
          city: "",
          state: "",
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          address: data.logradouro,
          neighborhood: data.bairro,
          city: data.localidade,
          state: data.estado,
        }));
      }
    } catch (error) {
      alert(t("common-address-fetch-error"));
    }
  };

  const changeContent = () => {
    setIsActive(!isActive); 
  };

  return (
    <>
      <HeaderSimple />
      <section className="newAccountForm">
        <div className="container">
          <h2>{t("new-account-title")}</h2>
          <form onSubmit={handleSubmit}>

            {/* first step */}
            <div className={`profile-step ${isActive ? 'show' : 'hide'}`}>
              <h4>{t("new-account-profile-select")}</h4>
              <ul className="row">
                <li>
                  <label>
                    <svg id="Camada_2" data-name="Camada 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 232.99 266.72">
                      <g id="Camada_1-2" data-name="Camada 1">
                        <path className="cls-1" d="M232.62,259.05c-14.1-33.13-35.98-59.27-67.72-76.75-3.42-1.88-8.37-2.96-11.81-4.92-4.07-2.31-6.85-6.36-11.49-7.71,11.41-10.19,21.66-20.81,29.05-34.39,2.01-3.69,5.31-13.72,6.92-15.71,2.71-3.36,10.72-2.9,13.95-11.62,5.24-14.14-7.42-16.37-8.57-22.39-1.14-5.98.41-15.88-.03-22.59C179.61,13.15,152.62-3.26,104.71.52c-44.14,3.49-52,34.28-54.61,72.29-.29,4.23.69,9.94-.03,13.74-.58,3.07-5.75,5.54-7.09,9.63-2.53,7.74-.19,15.91,6.76,20.25,1.99,1.25,5.28,1.27,6.7,3.14,2.43,3.2,5.64,12.86,8.24,17.33,3.25,5.58,7.7,11.73,11.95,16.58,4.28,4.89,11.02,9.42,14.81,13.72.75.85,1.27,1.1.95,2.47-14.32,9.51-29.66,14.27-43.61,24.78-20.19,15.2-38.12,39.05-46.89,62.93-.39,1.07-.69,2.18-.88,3.31l-1.01,6.02h232.99v-6.54M183.89,94.95c3.59,6.11,3.57,13.88-3.91,16.71l3.91-16.71ZM50.59,95.93l3.43,15.73c-6.13-2.4-8.15-10.93-3.43-15.73ZM163.71,191.35c4.2,1.79,14.73,9.63,18.68,12.81,17.52,14.1,31.31,34.43,40.51,54.9h-29.54c1.85-6.1-2.5-7.22-2.62-11.1-.13-4.43,3.11-11.65,3.03-16.73-.25-14.48-12.46-25.23-26.36-26.35l-5.15-13.06c-.21-.65.88-.72,1.45-.47ZM62.38,109.7c-3.21-11.94-4.39-15.73,5.41-24.12,28.17-24.13,90.5-2.17,85.48-56.91-.23-2.48-1.45-9.66-3.08-11.17-2.54-2.34-6.77-.54-7.45,2.38-.44,1.91,1.59,6.99,1.78,9.66,1.42,19.34-5,26.05-22.79,30.3-21.32,5.09-45.65,4.9-62.3,21.32-.7-34.44,4.15-68.43,45.28-71.79,37.38-3.05,62.63,4.63,68.22,44.88,4.15,29.84,2.97,56.71-13.61,82.51-7.95,12.37-27.22,34.34-43.52,32.72-22.93-2.27-47.89-39.23-53.42-59.79ZM132.28,216.95c-7.66,7.92-22.17,8.14-30.08.49-13.03-12.6-1.66-28.2.04-42.83,9.24,3.17,19.61,5.21,28.52,0,2.72,13.81,13.47,29.98,1.52,42.33ZM86.93,184.4c.97-.59,4.64-2.29,4.03.07-3.46,13.3-7.1,23.81,2.44,35.86,11.9,15.01,33.73,15.62,46.24,1.03,9.91-11.55,7.79-24.57,2.93-37.89,6.8-1.91,16.59,19.73,15.65,22.96-7.04,4.37-12.3,8.17-15.13,16.41-1.76,5.13-1.47,11.66-3.4,16.28-2.15,5.14-9.15,6.25-4.42,14.11,4.94,8.21,17.75,2.79,15.97-6.08-.48-2.37-2.73-3.95-2.79-7.09-.03-1.63,1.7-10.7,2.25-12.57,5.64-19.38,31.96-16.72,33.95,1.99.32,2.97-1.31,15.14-2.39,17.69-.62,1.47-2.65,1.76-3.74,3.19-2.44,3.23-2.77,6.24-1.86,8.68h-97.55c2.89-1.39,5.38-3.9,6.87-7.72,4.37-11.18-3.88-16.24-12.12-21.3-2.08-10.74,3.39-39.74,13.07-45.64ZM70.47,251.14c-4.86-1.44-4.89-8.97,0-10.42,10.41-3.09,10.41,13.51,0,10.42ZM71.25,190.36l-5.3,18.31c.31,3.3-1.01,6.46-1.14,9.68-.12,2.92,1.16,13.9.93,14.63-.34,1.05-5.04,3.61-6.53,7.32-3.61,8.99.96,15.96,7.42,18.77H10.09c12.52-28.83,33.35-53.63,61.16-68.69Z"/>
                      </g>
                    </svg>
                    <div className="row">
                      <input type="radio" value="veterinarian" name="profile_type" checked={formData.profile_type === "veterinarian"}
                        onChange={handleChange}/>
                      <p>{t("new-account-profile-veterinarian")}</p>
                    </div>
                  </label>
                </li>
                <li>
                  <label>
                      <svg id="Camada_2" data-name="Camada 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 234.69 269.03">
                        <g id="Camada_1-2" data-name="Camada 1">
                          <path className="cls-1" d="M234.63,257.09c0-.22-.01-.42-.02-.59-.33-12.48-.83-24.61-3.43-35.83-3.02-13-8.47-22.79-16.68-29.92-8.49-7.38-22.72-10.28-36.49-13.09-8.54-1.74-16.62-3.39-22.81-6-4.91-2.08-4.31-9.44-3.78-15.93.18-2.16.34-4.2.31-6,5.7-5.23,10.52-11.04,14.32-17.26,4.19-6.85,7.19-14.27,8.92-22.05,2.07-9.3,1.92-19.12,1.78-28.62-.17-11.32-.33-22.02,2.95-31.84.65-1.95,1.3-3.23,1.82-4.26,1.6-3.18,1.83-4.17-2.07-10.51-5.96-9.68-14.52-18.49-24.08-24.81-10.26-6.78-21.02-10.37-31.13-10.37-5.33,0-10.42,1.01-15.15,2.99-5.04,2.12-9.7,5.36-13.83,9.65-.82.85-1.88,2.37-3.01,3.97-1.14,1.62-2.86,4.07-3.49,4.38-.89.43-2.35.67-3.9.92-1.75.28-3.74.6-5.41,1.3-6.36,2.66-11.45,7.04-15.14,13-3.2,5.17-5.42,11.68-6.62,19.35-2.19,14.05-.73,29.59.99,42.95,2.8,21.71,10.57,37.7,25.2,51.77-.11,1.77.02,3.91.16,6.16.38,6.15.8,13.12-3.38,14.95-6.75,2.97-15.01,4.62-23.74,6.37-15.77,3.15-32.07,6.42-41.8,17.91C3.01,209.99.74,230.33.12,248.34c-.07,2-.17,6.48-.1,10.59.14,8.56.89,9.43,1.21,9.8l.25.3h231.77l.25-.3c1.17-1.37,1.3-5.65,1.12-11.65ZM124.54,8.17c8.7,0,18.22,3.56,27.53,10.31,8.16,5.91,16.03,14.19,22.17,23.34-.03.92-1.08,4.07-1.73,6-.58,1.73-1.13,3.37-1.33,4.33-.35,1.65-1.78,8.83-1.78,11.19v9.35c-8.32-10.34-16.51-15.22-27.02-16.2-.64-.06-1.31-.09-2.07-.09-3.36,0-7.47.6-11.83,1.23-5.01.73-10.2,1.48-15.03,1.48-7.89,0-12.8-2.04-15.44-6.43-.32-.53-.56-1.34-.8-2.11-.37-1.21-.71-2.35-1.44-3.01-.73-.66-1.73-.99-2.97-.99-5.48,0-14.79,6.35-17.57,8.88-4.62,4.2-8.02,9.71-11.18,15.23-.4-8.13.78-16.18,3.39-22.91,3.31-8.54,8.73-14.42,15.67-17.02,1.43-.53,2.98-.72,4.48-.89,1.64-.19,3.2-.37,4.54-.99,1.46-.67,3.13-3.03,4.89-5.54.96-1.36,1.87-2.64,2.6-3.43,7.25-7.77,15.63-11.72,24.9-11.72ZM71.46,73.01c4.54-9.09,11.58-15.15,19.88-17.13,1.58,3.83,4.48,6.82,8.61,8.9,4.2,2.11,8.89,2.83,12.07,3.07.95.07,1.93.11,2.92.11,4.66,0,9.06-.78,13.31-1.54,4.07-.72,7.92-1.41,11.81-1.41,6.78,0,12.29,2.12,17.88,6.86,6.57,5.58,10.2,12.24,11.1,20.36.78,7.02-.5,15.04-3.93,24.5-2.2,6.08-5.06,11.58-8.5,16.33-3.25,4.49-7.03,8.34-11.23,11.44-7.95,5.86-17.3,8.96-27.02,8.96-11.85,0-23.41-4.6-32.57-12.97-10.03-9.16-16.56-22.16-18.87-37.58-1.53-10.2.12-21.1,4.52-29.91ZM189.66,234.07h-.01c-.25,0-.93,0-2.5,1.57-1.52,1.5-1.52,1.97-1.52,2.17v23.2h-63.88v-63.77c.28-.4,1.25-1.49,2.05-2.37,1.4-1.56,2.86-3.18,3.36-4.06,1.26-2.18,1.93-4.59,2.58-6.92.31-1.1.62-2.23,1-3.32l15.05-5.81c.61.47,1.16.93,1.7,1.37,1.65,1.36,3.2,2.65,5.69,3.61,7.55,2.89,16.16,4.76,24.49,6.57,7.09,1.54,14.41,3.12,20.98,5.33,6.32,2.12,11.62,5.74,15.76,10.77,3.69,4.48,6.57,10.24,8.57,17.11,3.9,13.4,4,29.11,3.59,41.49h-32.88v-22.38c0-1.19-2.32-4.55-4.02-4.55ZM100.53,169.76c-3.68-1.28-7.49-2.6-9.11-4.06v-10.77c8.29,4.86,17.15,7.33,26.36,7.33,8.73,0,17.31-2.21,25.54-6.58v11.03l-18.35,7.15-.13.13c-.59.59-1,2.06-1.81,5.06-.62,2.31-1.4,5.17-2.33,7.37-.93,2.18-1.9,3.39-2.73,3.39h0c-.39,0-.84-.25-1.34-.74-2.54-2.5-2.97-5.33-3.43-8.33-.2-1.33-.41-2.71-.81-4.1-.87-3.05-6.2-4.9-11.85-6.86ZM89.56,174.86c2.33,0,7.24,2.25,10.82,3.89,1.74.8,3.27,1.5,4.35,1.88.58,1.35.95,2.72,1.34,4.17.54,1.98,1.09,4.02,2.21,6,.93,1.64,2.12,2.8,3.28,3.92,1.08,1.05,2.1,2.04,2.84,3.35v62.93H49.81v-23.2c0-1.98-1.47-3.32-3.65-3.32-1.81,0-3.69.94-3.69,2.5v24.01H7.53c.09-2.25.15-4.51.22-6.88.28-9.8.58-19.93,2.46-29.36,2.12-10.61,5.99-18.69,11.84-24.69,8.12-8.33,24.56-11.81,39.05-14.87,7.89-1.67,15.35-3.24,21.16-5.46,2.02-.77,3.35-2.01,4.52-3.11.75-.7,1.39-1.3,2.08-1.66.08-.04.28-.11.68-.11Z"/>
                        </g>
                      </svg>
                      <div className="row">
                        <input type="radio" value="breeder" name="profile_type" checked={formData.profile_type === "breeder"}
                          onChange={handleChange}/>
                        <p>{t("new-account-profile-breeder")}</p>
                      </div>
                  </label>
                </li>
                <li>
                  <label>
                    <svg id="Camada_2" data-name="Camada 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 227.33 266.67">
                      <g id="Camada_1-2" data-name="Camada 1">
                        <path className="cls-1" d="M197.5,196.29c-8-2.73-16.68-5.11-25.07-7.42-5.11-1.41-10.4-2.86-15.39-4.35-.61-.18-1.62-.41-2.9-.69-1.96-.43-6.36-1.39-7.63-2.1-.2-2.57-.17-14.52.06-16.32.35-.48,1.81-1.46,2.7-2.05,1.04-.7,2.04-1.37,2.75-2.04,2.86-.28,5.94-.41,9.63-.41,3.26,0,6.62.11,9.86.21,3.25.1,6.61.21,9.88.21,2.89,0,5.44-.08,7.79-.25h.19c1.74-.13,3.38-.33,4.29-1.41.41-.48.79-.94,2.81-12.84l.07-.4c3.99-23.39,6.56-57.59-3.88-87.67-4.89-14.07-12.21-25.91-21.76-35.17-10.55-10.23-23.95-17.45-39.85-21.47-5.55-1.4-11.34-2.11-17.2-2.11-14.82,0-29.77,4.43-43.26,12.81-13.37,8.31-24.03,19.7-30.83,32.95-7,13.64-11.12,30.3-12.23,49.54-.92,15.82.19,33.02,3.27,51.12.09.5.2,1.24.33,2.1.9,5.83,1.52,9.23,2.18,10.51.94,1.8,3.2,1.93,4.55,2.01.11,0,.21.01.3.02,2.34.16,4.88.24,7.75.24,3.27,0,6.62-.1,9.85-.2,3.23-.1,6.57-.2,9.82-.2,3.71,0,6.82.13,9.71.4.7.68,1.64,1.25,2.62,1.85.73.44,1.93,1.17,2.21,1.58.2,1.73.32,13.48.19,17.12l-50.48,14.43-.08.03c-11.11,4.43-19.16,13.01-23.94,25.5C1.26,233.8.34,247.6.06,256.93v.45c-.11,2.8-.2,5.7,1.64,7.61,1.08,1.12,2.67,1.68,4.73,1.68h214.5c2.07,0,3.61-.53,4.69-1.62,1.55-1.55,1.72-3.89,1.72-5.5-.07-19.85-4.03-54.46-29.83-63.26ZM164.07,145.95c1.65-2.66,3.36-5.41,4.67-8.39,2.17-4.93,4.47-12.6,5.87-19.53,1.26-6.26,2.38-14.83.56-20.1-1.57-4.55-6.26-12.27-10.18-15.79-6.25-5.61-13.77-7.6-21.04-9.54-9.58-2.55-18.63-4.95-24.73-15.22-.25-.43-.46-1.03-.68-1.67-.63-1.85-1.57-4.64-5-4.64-.09,0-.18,0-.28,0-2.3.11-3.79,3.03-5.68,6.72-.89,1.74-1.81,3.53-2.52,4.32-5.91,6.48-12.71,7.99-19.9,9.58-3.89.86-7.91,1.75-11.75,3.49-9.53,4.31-17.28,12.25-20.75,21.24-2.3,5.95-1.33,14.78-.12,21.13,1.36,7.1,3.76,14.94,6.28,20.46,1.28,2.81,2.9,5.41,4.47,7.93,1.13,1.82,2.22,3.57,3.18,5.37h-25.17c-3.39-17.98-4.97-33.71-4.81-48.04.2-18.31,3.33-34.46,9.3-48.01C57.79,28.01,84.72,10.39,114.37,10.39c18.68,0,36.43,7.24,49.98,20.39,25.06,24.31,32.36,64.86,21.71,120.55h-25.18c.96-1.8,2.05-3.55,3.18-5.38ZM62.06,98.36c5.28-10.99,13.22-13.14,22.4-15.64,4.42-1.2,8.98-2.44,13.6-4.73,5.96-2.97,11.29-5.93,15.68-11.7.08.12.16.23.22.33.33.49.66,1,1.05,1.38.81.82,1.59,1.44,2.34,2.03.47.37.91.72,1.35,1.11,8.16,7.26,14.19,8.65,20.57,10.12,3.61.83,7.35,1.69,11.89,3.65,6.95,2.99,11.62,7.68,13.86,13.92,3.45,9.59,1.15,23.41-6.3,37.93-4.83,9.42-11.69,17.16-19.83,22.41-7.8,5.02-16.61,7.67-25.49,7.67-7.57,0-14.84-1.87-21.62-5.56-7.2-3.92-13.48-9.71-18.67-17.21-3.79-5.49-7.78-14.39-10.16-22.68-2.88-10.05-3.2-18.23-.88-23.04ZM169.14,212.89c-1.74,2.01-3.54,4.1-5.24,6.19-6.42,7.92-12.98,15.92-19.32,23.66-2.05,2.5-4.09,5-6.13,7.48-.24.29-.56.78-1.12,1.62-.7,1.06-2.49,3.77-3.31,4.45h-6.7l17.77-64.35,33.31,9.42c-2.77,4.01-6.06,7.82-9.26,11.52ZM51.06,203.94c-.83-.82-1.63-1.61-2.28-2.52l33.2-9.45,17.45,64.37c-.2,0-.39.02-.58.02-.79.03-1.47.06-2.09.06-2.39,0-3.79-.33-6.3-3.33-8.58-10.26-17.17-21.25-25.47-31.87-3.83-4.91-7.8-9.98-11.68-14.88-.71-.9-1.49-1.67-2.25-2.41ZM106.48,198.4c-3.16-.21-12.12-1.49-13.52-2.2q-.4-.2-.7-.88c-.42-.96-2.78-9.13-2.98-10.28v-13.98c1.96.55,3.96,1.27,5.73,1.93,6.95,2.59,11.22,4.05,18.26,4.05,1.07,0,2.17-.03,3.36-.1,6.61-.38,11.86-2.34,17.42-4.42,1.11-.41,2.23-.84,3.39-1.25v13.78c-.21,1.31-2.76,9.44-3.45,11.06-.51.31-2.45,1.16-9.02,1.78-4.06.38-9.35.61-14.15.61-1.83,0-3.41-.04-4.34-.1ZM131.1,207.16l-13.67,49.06h-8.14s-13.67-49.09-13.67-49.09c6.24.72,12.2,1.07,18.14,1.07s11.59-.34,17.34-1.05ZM9.79,256.29c.13-19.35,3.18-28.27,5.85-33.89,3.33-7.01,9.95-13.44,14.17-15.38,1.38-.64,2.84-1.06,4.38-1.5,1.38-.4,2.8-.81,4.19-1.39l42.51,52.17H9.79ZM146.42,256.29l41.9-52.3c1.44.57,2.9.98,4.33,1.38,1.72.48,3.35.94,4.9,1.65,8.1,3.73,14.54,14.83,17.09,23.56,2.44,8.36,2.84,17.55,2.92,25.71h-71.13Z"/>
                      </g>
                    </svg>
                    <div className="row">
                      <input type="radio" value="attendant" name="profile_type" checked={formData.profile_type === "attendant"}
                        onChange={handleChange}/>
                      <p>{t("new-account-profile-attendant")}</p>
                    </div>
                  </label>
                </li>
              </ul>
              <span
              onClick={formData.profile_type ? changeContent : null}
              className={`${isSelected ? 'enabled' : 'disabled'}`}>{t("new-account-next-step")}</span>
            </div>

            <div className={`second-part-step ${isActive ? 'hide' : 'show'}`}>
              {/* second step */}
              <div className="data-step">
              <div>
                <Select
                  options={COUNTRY_OPTIONS}
                  classNamePrefix="select"
                  placeholder={t("new-account-select-country")}
                  value={COUNTRY_OPTIONS.find((opt) => opt.value === formData.country) || null}
                  onChange={(option) => {
                    setFormData((prev) => ({
                      ...prev,
                      country: option ? option.value : "",
                    }));
                    setErrors((prevErrors) => ({ ...prevErrors, country: null }));
                  }}
                />
                {errors.country && <p className="error">{errors.country}</p>}
              </div>
              <div>
                <input
                  name="name"
                  value={formData.name}
                  placeholder={t("new-account-input-2")}
                  onChange={handleInputChange}
                />
                {errors.name && <p className="error">{errors.name}</p>}
              </div>
              <div>
                <InputMask
                  key={`phone-${formData.country}-${isClearing}`}
                  mask={
                    (!isClearing
                      ? formData.country === "Brasil"
                      ? "+99 (99) 99999-9999"
                      : formData.country === "Argentina"
                      ? "+99 (999) 9999-9999"
                      : formData.country === "Paraguay"
                      ? "+999 (999) 999-999"
                      : formData.country === "Colombia"
                      ? "+57 999 999 9999"
                      : formData.country === "Uruguay"
                      ? "+999 999 999 999"
                      : ""
                      : "") || false
                  }
                  placeholder={t("new-account-input-5")}
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                />
                {errors.phone && <p className="error">{errors.phone}</p>}
              </div>
              <div>
                <input
                  placeholder={t("new-account-input-6")}
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
                {errors.email && <p className="error">{errors.email}</p>}
              </div>
              <div>
                <InputMask
                  key={`cpf-${formData.country}-${isClearing}`}
                  mask={
                    (!isClearing
                      ? formData.country === "Brasil"
                      ? "999.999.999-99"
                      : formData.country === "Argentina"
                      ? "99-99999999-9"
                      : formData.country === "Paraguay"
                      ? "9999999"
                      : formData.country === "Colombia"
                      ? "9999999999"
                      : formData.country === "Uruguay"
                      ? "9.999.999-9"
                      : ""
                      : "") || false
                  }
                  placeholder={t("new-account-document-placeholder")}
                  name="cpf"
                  value={formData.cpf}
                  onChange={handleInputChange}
                />
                {errors.cpf && <p className="error">{errors.cpf}</p>}
              </div>
              <div>
                <input
                  placeholder={
                    !isClearing
                    ? formData.profile_type === "veterinarian"
                      ? t("new-account-profile-name-veterinarian")
                      : formData.profile_type === "attendant"
                      ? t("new-account-profile-name-attendant")
                      : formData.profile_type === "breeder"
                      ? t("new-account-profile-name-breeder")
                      : ""
                    : ""
                  }
                  name="profile_name"
                  value={formData.profile_name}
                  onChange={handleInputChange}
                />
                {errors.profile_name && <p className="error">{errors.profile_name}</p>}
              </div>
              {formData.profile_type !== "breeder" && (
                <div>
                <InputMask
                  key={`profile-value-${formData.profile_type}-${formData.country}-${isClearing}`}
                  mask={
                    (!isClearing
                      ? formData.profile_type === "veterinarian"
                        ? formData.country === "Brasil"
                          ? "999/99"
                          : formData.country === "Argentina"
                          ? "99999"
                          : formData.country === "Paraguay"
                          ? "99999"
                          : formData.country === "Uruguay"
                          ? "99999"
                          : ""
                        : formData.profile_type === "attendant"
                        ? formData.country === "Brasil"
                          ? "99.999.999/9999-99"
                          : formData.country === "Argentina"
                          ? "99-99999999-9"
                          : formData.country === "Paraguay"
                          ? "99999999-9"
                          : formData.country === "Colombia"
                          ? "999999999-9"
                          : formData.country === "Uruguay"
                          ? "99999999999-9"
                          : ""
                        : ""
                      : "") || false
                  }
                  placeholder={
                    !isClearing
                      ? formData.profile_type === "veterinarian"
                        ? "CRMV/CPMV/CMVP/CVU/MV/MVZ/COMVEZCOL"
                        : formData.profile_type === "attendant"
                        ? "CNPJ/CUIT/RUC/RUT/NIT"
                        : ""
                      : ""
                  }
                  name="profile_value"
                  value={formData.profile_value}
                  onChange={handleInputChange}
                />
                {errors.profile_value && <p className="error">{errors.profile_value}</p>}
                </div>
              )}
              <div>
                <input
                  placeholder={t("new-account-promoter-code-placeholder")}
                  onChange={handleInputChange}
                  name="code"
                  value={formData.code}
                />
                {errors.code && <p className="error">{errors.code}</p>}
              </div>
              <div>
                <input
                  placeholder={t("new-account-input-7")}
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                />
                {errors.password && <p className="error">{errors.password}</p>}
              </div>
              <div>
                <input
                  placeholder={t("new-account-input-8")}
                  type="password"
                  name="password_confirmation"
                  value={formData.password_confirmation}
                  onChange={handleInputChange}
                />
                {errors.password_confirmation && <p className="error">{errors.password_confirmation}</p>}
              </div>
              </div>
              
              {/* third step */}
              <div className="address-step">
              <div>
                {formData.country === "Argentina" ? (
                  <input
                    id="cep"
                    name="cep"
                    type="text"
                    value={formData.cep}
                    onChange={handleCepChange}
                    placeholder={t("edit-address-input-2")}
                  />
                ) : (
                  <InputMask
                    id="cep"
                    key={`cep-${formData.country}-${isClearing}`}
                    mask={
                      (!isClearing
                        ? formData.country === "Brasil"
                          ? "99999-999"
                          : formData.country === "Paraguay"
                          ? "99999"
                          : formData.country === "Colombia"
                          ? "999999"
                          : formData.country === "Uruguay"
                          ? "99999"
                          : ""
                        : "") || false
                    }
                    name="cep"
                    type="text"
                    value={formData.cep}
                    onChange={handleCepChange}
                    placeholder={t("edit-address-input-2")}
                  />
                )}
                {errors.cep && <p className="error">{errors.cep}</p>}
              </div>
              <div>
                <input
                  placeholder={t("edit-address-input-5")}
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                />
                {errors.address && <p className="error">{errors.address}</p>}
              </div>
              <div>
                <input
                  placeholder={t("edit-address-input-4")}
                  type="text"
                  name="neighborhood"
                  value={formData.neighborhood}
                  onChange={handleInputChange}
                />
                {errors.neighborhood && <p className="error">{errors.neighborhood}</p>}
              </div>
              <div>
                <input
                  placeholder={t("edit-address-input-3")}
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
                />
                {errors.city && <p className="error">{errors.city}</p>}
              </div>
              <div>
                <input
                  placeholder={t("edit-address-input-1")}
                  type="text"
                  name="state"
                  value={formData.state}
                  onChange={handleInputChange}
                />
                {errors.state && <p className="error">{errors.state}</p>}
              </div>
              <div>
                <input
                  placeholder={t("edit-address-input-6")}
                  type="text"
                  name="number"
                  value={formData.number}
                  onChange={handleInputChange}
                />
                {errors.number && <p className="error">{errors.number}</p>}
              </div>
              <div>
                <input
                  placeholder={t("edit-address-input-7")}
                  type="text"
                  name="complement"
                  value={formData.complement}
                  onChange={handleInputChange}
                />
                {errors.complement && <p className="error">{errors.complement}</p>}
              </div>
              </div>

              {/* accept regulation */}
              <div className="accept-regulation">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.accept_regulation || false}
                    onChange={handleCheckboxChange}
                    name="accept_regulation"
                    className="accept_regulation"
                  />
                  <p>
                    {t("accept-regulation-1")}
                    <Link to="/regulamento">{t("accept-regulation-2")}</Link>
                    {t("accept-regulation-3")}
                    <Link to="/politicas-de-privacidade">{t("accept-regulation-4")}</Link>
                    {t("accept-regulation-5")}
                  </p>
                </label>
                {errors.accept_regulation && <p className="error">{errors.accept_regulation}</p>}
              </div>

              {errors.general && <p className="error">{errors.general}</p>}
              <div className="row buttons">
                <span onClick={changeContent}>{t("go-back")}</span>
                <button type="submit">{t("new-account-button")}</button>
              </div>
            </div>

          </form>
        </div>
      </section>
    </>
  );
}

export default NewAccountForm;
